import { medias } from '@/utils/sizes';
import styled from 'styled-components';

export const ProjectTable = styled.div`
  --row-height-mobile: 51px;
  --content-height: auto;

  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Row = styled.div`
  display: grid;
  box-sizing: border-box;
  grid-template-columns: 1fr 1fr;
  align-items: flex-start;
  border-bottom: 1px solid var(--c-border);
  padding: calc(var(--fs-base) * 1) 0;

  p:first-child {
    text-transform: uppercase;
  }

  ${medias.min.tablet} {
    p:last-child {
      padding-right: 30px;
      box-sizing: border-box;
    }
  }

  ${medias.max.tablet} {
    height: max-content;
    min-height: var(--row-height-mobile);
    border-bottom: none;
    border-top: 1px solid var(--c-border);
  }

  p.typography {
    line-height: var(--lh-sm);
  }
`;

export const CollapsibleContent = styled.div.withConfig({
  shouldForwardProp: (prop) => !['isCollapsible', 'isExpanded'].includes(prop),
})<{
  isCollapsible: boolean;
  isExpanded: boolean;
}>`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  opacity: 1;
  transition:
    height 0.3s,
    opacity 0.2s 0.1s;

  ${medias.only.mobile} {
    ${({ isCollapsible, isExpanded }) =>
      isCollapsible &&
      `
      display: grid;
      grid-template-columns: 100%;
      grid-template-rows: max-content;
      opacity: ${isExpanded ? 1 : 0};
      height: ${isExpanded ? 'var(--content-height)' : '1px'};
  `}

    .typography {
      margin: auto 0;
    }

    .table-key {
      font-size: 14px;
    }
  }
`;

export const CollapsibleHeader = styled.div`
  cursor: pointer;
  display: flex;
  min-height: var(--row-height-mobile);
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid var(--c-border);
  border-bottom: 1px solid var(--c-border);
  margin-bottom: -1px;

  ${medias.min.tablet} {
    display: none;
  }

  ${medias.max.mobile} {
    .typography {
      font-size: var(--fs-lg);
    }
  }
`;
